export default __webpack_public_path__ + "static/media/megaphone.35b2ff51.svg";